import React from "react"

import SEO from "../components/seo"
import Link from "../utils/link"

// NOTE: Placeholder legal copy below. Replace the body text with Wingspan
// Capital's legal-approved Privacy Policy before go-live.
import "./legal.scss"

const PrivacyPolicy = () => (
  <>
    <SEO
      title="Privacy Policy"
      description="Wingspan Capital's Privacy Policy — how we collect, use and protect your personal information."
      path="/privacy-policy"
    />
    <article className="legal">
      <h1 className="legal__title">Privacy Policy</h1>
      <p className="legal__updated">Last updated: June 2026</p>

      <section className="legal__section">
        <p>
          Wingspan Capital (&ldquo;Wingspan&rdquo;, &ldquo;we&rdquo;,
          &ldquo;us&rdquo; or &ldquo;our&rdquo;) is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, disclose
          and safeguard your personal information in accordance with the
          Privacy Act 1988 (Cth) and the Australian Privacy Principles.
        </p>
      </section>

      <section className="legal__section">
        <h2>Information we collect</h2>
        <p>
          We may collect personal information that you provide to us directly,
          including your name, email address, telephone number and any details
          you include in an enquiry. We may also collect information
          automatically when you interact with our website.
        </p>
      </section>

      <section className="legal__section">
        <h2>How we use your information</h2>
        <p>We use the personal information we collect to:</p>
        <ul>
          <li>respond to your enquiries and provide our services;</li>
          <li>
            send you fund updates, market insights and other communications
            where you have consented to receive them;
          </li>
          <li>improve our website and the services we offer; and</li>
          <li>comply with our legal and regulatory obligations.</li>
        </ul>
      </section>

      <section className="legal__section">
        <h2>Disclosure of your information</h2>
        <p>
          We do not sell your personal information. We may disclose it to
          trusted service providers who assist us in operating our business,
          and where required or permitted by law.
        </p>
      </section>

      <section className="legal__section">
        <h2>Marketing communications</h2>
        <p>
          Where you have consented, we may send you communications about our
          funds and market insights. You can unsubscribe at any time by using
          the unsubscribe link in our emails or by contacting us.
        </p>
      </section>

      <section className="legal__section">
        <h2>Security</h2>
        <p>
          We take reasonable steps to protect the personal information we hold
          from misuse, interference, loss and unauthorised access,
          modification or disclosure.
        </p>
      </section>

      <section className="legal__section">
        <h2>Access and correction</h2>
        <p>
          You may request access to, or correction of, the personal
          information we hold about you. To make a request, please contact us
          using the details below.
        </p>
      </section>

      <section className="legal__section">
        <h2>Contact us</h2>
        <p>
          If you have any questions about this Privacy Policy or how we handle
          your personal information, please <Link to="/contact">contact us</Link>.
        </p>
      </section>
    </article>
  </>
)

export default PrivacyPolicy
